import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { client } from '@trello/graphql';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { AboutThisBoardModalProps } from './AboutThisBoardModal';

export const LazyAboutThisBoardModal: FunctionComponent<
  AboutThisBoardModalProps
> = (props) => {
  const AboutThisBoardModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "about-this-board-modal" */ './AboutThisBoardModal'
      ),
    { preload: false, namedImport: 'AboutThisBoardModal' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-workflowers',
          feature: 'About This Board Modal',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <ApolloProvider client={client}>
            <AboutThisBoardModal {...props} />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
